import v2 from './v2'

const migrations = {
  '2': v2,
}

export default migrations
